module.exports = __webpack_public_path__ + "assets/img/u=1367050145,1852793189&fm=26&gp=0.4bd92f50.jpg";